import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GoToItem } from '../../models/results-types';

@Component({
  selector: 'go-to-item',
  templateUrl: './go-to-item.component.html',
  styleUrls: ['./go-to-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoToItemComponent {
  private _model: GoToItem;
  public get model(): GoToItem {
    return this._model;
  }
  @Input()
  public set model(value: GoToItem) {
    this._model = value;
  }
  @Input() selected: boolean;
}
